import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import useForm from 'react-hook-form';
import axios from 'axios';
import api from '../../../config/axios';

const ModalObservation = (props) => {
    const { visible, onSave, handleClose, observationClosestPurchase, transactionId, purchase } =
        props;
    const { handleSubmit, register } = useForm();

    const [pagoPendiente, setPagoPendiente] = useState(false);
    const [vacioPendiente, setVacioPendiente] = useState(false);
    const [montoFavor, setMontoFavor] = useState(false);
    const [montoRecibido, setMontoRecibido] = useState(false);
    const [sinNovedad, setSinNovedad] = useState(false);

    // Estados para los nuevos campos
    const [addressType, setAddressType] = useState('');
    const [coolingDispenser, setCoolingDispenser] = useState(null);
    const [publicSite, setPublicSite] = useState(null);

    // Función para obtener los valores seleccionados de los campos radio
    const getSelectedAddressData = () => {
        return {
            type: addressType,
            coolingDispenser: coolingDispenser,
            publicSite: publicSite,
        };
    };

    // Función para validar que todos los campos estén seleccionados
    const validateAddressData = () => {
        const errors = [];

        // si la información extra del domicilio ya existe, no se valida
        if (purchase.address.type !== null) {
            return {
                isValid: true,
            };
        }

        if (!addressType) {
            errors.push('Debe seleccionar un tipo de domicilio');
        }

        if (coolingDispenser === null) {
            errors.push('Debe indicar si tiene dispensador vertical');
        }

        if (publicSite === null) {
            errors.push('Debe indicar si es un sitio público');
        }

        return {
            isValid: errors.length === 0,
            errors: errors,
        };
    };

    // Función para resetear los valores de los campos
    const resetAddressData = () => {
        setAddressType('');
        setCoolingDispenser(null);
        setPublicSite(null);
    };

    const buildObservationMessage = (
        pagoPendienteMsg,
        vacioPendienteMsg,
        montoFavorMsg,
        observacionFinalMsg,
        pagoPendienteMotivoMsg,
        montoRecibidoMsg,
    ) => {
        let allFieldsNull = true;

        Object.values({
            pagoPendienteMsg,
            vacioPendienteMsg,
            montoFavorMsg,
            observacionFinalMsg,
            pagoPendienteMotivoMsg,
            montoRecibidoMsg,
        }).map((value) => {
            if (!!value) allFieldsNull = false;
        });

        if (allFieldsNull) return null;

        const paymentNameShort = purchase.paymentMethod.name.split(' ')[0].toLowerCase();
        const pagoPendienteText = pagoPendienteMsg
            ? `Pago pendiente: ${pagoPendienteMsg} ${paymentNameShort} ${pagoPendienteMotivoMsg ? `(${pagoPendienteMotivoMsg})` : ''}. `
            : '';
        const vacioPendienteText = vacioPendienteMsg
            ? `${vacioPendienteMsg} vacio(s) por reclamar. `
            : '';
        const montoFavorText = montoFavorMsg
            ? `Tiene a favor: ${montoFavorMsg} ${paymentNameShort}. `
            : '';
        const montoRecibidoText = montoRecibidoMsg
            ? `Monto que recibí (pagos pendientes): ${montoRecibidoMsg} ${paymentNameShort}. `
            : '';
        const observacionFinalText = observacionFinalMsg ? `*${observacionFinalMsg}.` : '';

        return `${pagoPendienteText}${vacioPendienteText}${montoFavorText}${montoRecibidoText}${observacionFinalText}`;
    };

    const handleSave = async (data) => {
        // Validar los datos de dirección antes de guardar
        const addressValidation = validateAddressData();
        if (!addressValidation.isValid) {
            alert('Error: ' + addressValidation.errors.join(', '));
            return;
        }

        // Obtener los datos de dirección seleccionados
        const addressData = purchase.address.type === null ? getSelectedAddressData() : null;

        const observacionFinal = buildObservationMessage(
            data.pagoPendienteMsg,
            data.vacioPendienteMsg,
            data.montoFavorMsg,
            data.observationMsg,
            data.pagoPendienteMotivoMsg,
            data.montoRecibidoMsg,
        );

        // transactionId is undefined when order is delivered
        // is ! null when transaction need to be updated
        if (data.photoOrder.length > 0) {
            const imageUrl = await compressAndUpload(data.photoOrder[0]);
            onSave(observacionFinal, transactionId, imageUrl, addressData);
        } else {
            onSave(observacionFinal, transactionId, null, addressData);
        }
    };

    const compressAndUpload = async (file) => {
        // Comprimir
        const compressedBlob = await compressImage(file);

        // Convertir Blob a Buffer/ArrayBuffer para S3
        const arrayBuffer = await compressedBlob.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);

        // Subir a S3
        const imageUrl = await handleImageS3(file, buffer, purchase.id);
        return imageUrl;
    };

    const compressImage = async (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Redimensionar manteniendo proporción
                const maxWidth = 600;
                const ratio = maxWidth / img.width;
                canvas.width = maxWidth;
                canvas.height = img.height * ratio;

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                // Comprimir a JPEG
                canvas.toBlob(
                    (blob) => {
                        resolve(blob);
                    },
                    'image/jpg',
                    0.8,
                );
            };
        });
    };

    /**
     * Handle request of signed URL and upload procces of files to AWS S3
     * @param {Object} data Information about category (name, image, src)
     * @return {String} URL to store in DB
     */
    const handleImageS3 = async (file, buffer, idPurchase) => {
        const fileName = `purchases/${idPurchase}-observation.${file.type.split('/')[1]}`;
        const fileType = file.type;
        const requestSigning = {
            fileName,
            fileType,
        };

        // request signedurl to AWS
        const responseAWS = await api.post('/aws/request-url-signed', requestSigning);
        const { signedRequest, url } = responseAWS.data.data;

        // upload image directly to S3 bucket
        try {
            await axios({
                url: signedRequest,
                method: 'PUT',
                data: buffer,
                headers: {
                    'Content-Type': fileType,
                },
            });
            return url;
        } catch (e) {
            console.log(e);
        }
    };

    const handleInputImage = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        if (!file) return;
        //const imgs = dummyimgs;

        reader.onloadend = () => {
            // imgs[i].img = reader.result;
            // imgs[i].update = false;
            // setDummyImgs(imgs);
            // setFile(file);
        };
        reader.readAsDataURL(file);
    };

    const renderMetadata = () => {
        return (
            <div>
                <p>
                    <strong>Información adicional de la dirección</strong>
                </p>
                <br />
                <div>
                    <label>
                        <strong>Tipo de domicilio</strong>
                    </label>
                    <div>
                        <input
                            type="radio"
                            id="typeCasa"
                            name="addressType"
                            value="casa"
                            checked={addressType === 'casa'}
                            onChange={(e) => setAddressType(e.target.value)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="typeCasa">Casa</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="typeApartamento"
                            name="addressType"
                            value="apartamento"
                            checked={addressType === 'apartamento'}
                            onChange={(e) => setAddressType(e.target.value)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="typeApartamento">Apartamento</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="typeConsultorio"
                            name="addressType"
                            value="consultorio"
                            checked={addressType === 'consultorio'}
                            onChange={(e) => setAddressType(e.target.value)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="typeConsultorio">Consultorio</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="typeNegocio"
                            name="addressType"
                            value="negocio"
                            checked={addressType === 'negocio'}
                            onChange={(e) => setAddressType(e.target.value)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="typeNegocio">Negocio</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="typeOther"
                            name="addressType"
                            value="otro"
                            checked={addressType === 'otro'}
                            onChange={(e) => setAddressType(e.target.value)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="typeOther">Otro</label>
                    </div>
                    <hr />
                </div>
                <div>
                    <label>
                        <strong>Dispensador (vertical)</strong>
                    </label>
                    <div>
                        <input
                            type="radio"
                            id="coolingDispenserYes"
                            name="coolingDispenser"
                            value="true"
                            checked={coolingDispenser === true}
                            onChange={() => setCoolingDispenser(true)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="coolingDispenserYes">Sí</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="coolingDispenserNo"
                            name="coolingDispenser"
                            value="false"
                            checked={coolingDispenser === false}
                            onChange={() => setCoolingDispenser(false)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="coolingDispenserNo">No</label>
                    </div>
                    <hr />
                </div>
                <div>
                    <label>
                        <strong>Sitio público</strong>
                    </label>
                    <div>
                        <input
                            type="radio"
                            id="publicSiteYes"
                            name="publicSite"
                            value="true"
                            checked={publicSite === true}
                            onChange={() => setPublicSite(true)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="publicSiteYes">Sí</label>
                    </div>
                    <div>
                        <input
                            type="radio"
                            id="publicSiteNo"
                            name="publicSite"
                            value="false"
                            checked={publicSite === false}
                            onChange={() => setPublicSite(false)}
                        />
                        &nbsp;&nbsp;
                        <label htmlFor="publicSiteNo">No</label>
                    </div>
                    <hr />
                </div>
            </div>
        );
    };

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Entregar Pedido
                </h5>
            </div>
            <div className="modal-body modal-body-observation">
                {observationClosestPurchase && (
                    <div className="form-group">
                        {observationClosestPurchase}
                        <hr />
                    </div>
                )}
                <div className="form-group">
                    {purchase.address.type === null && renderMetadata()}
                    <div>
                        <div>
                            <input
                                type="checkbox"
                                id="pagoPendiente"
                                name="contact"
                                value="express"
                                checked={pagoPendiente}
                                onChange={() => setPagoPendiente(!pagoPendiente)}
                            />
                            &nbsp;&nbsp;
                            <label htmlFor="pagoPendiente">Pago pendiente</label>
                        </div>
                        {pagoPendiente && (
                            <div className="form-group">
                                <input
                                    className="form-control mb-3"
                                    placeholder="Ejm: 12.000 ó 4.000"
                                    name="pagoPendienteMsg"
                                    type="text"
                                    inputMode="numeric"
                                    ref={register({
                                        required: false,
                                    })}
                                />
                                <input
                                    className="form-control mb-3"
                                    placeholder="Motivo"
                                    name="pagoPendienteMotivoMsg"
                                    type="text"
                                    inputMode="text"
                                    ref={register({
                                        required: false,
                                    })}
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <div>
                            <input
                                type="checkbox"
                                id="vacioPendiente"
                                name="contact"
                                value="express"
                                checked={vacioPendiente}
                                onChange={() => setVacioPendiente(!vacioPendiente)}
                            />
                            &nbsp;&nbsp;
                            <label htmlFor="vacioPendiente">Vacio(s) pendiente</label>
                        </div>
                        {vacioPendiente && (
                            <input
                                className="form-control mb-3"
                                placeholder="Ejm: 1 ó 2"
                                name="vacioPendienteMsg"
                                type="text"
                                inputMode="numeric"
                                ref={register({
                                    required: false,
                                })}
                            />
                        )}
                    </div>
                    <div>
                        <div>
                            <input
                                type="checkbox"
                                id="montoFavor"
                                name="contact"
                                value="express"
                                checked={montoFavor}
                                onChange={() => setMontoFavor(!montoFavor)}
                            />
                            &nbsp;&nbsp;
                            <label htmlFor="montoFavor">Monto a favor</label>
                        </div>
                        {montoFavor && (
                            <input
                                className="form-control mb-3"
                                placeholder="Ejm: 12.000 ó 4.000"
                                name="montoFavorMsg"
                                type="text"
                                inputMode="numeric"
                                ref={register({
                                    required: false,
                                })}
                            />
                        )}
                    </div>
                    <div>
                        <div>
                            <input
                                type="checkbox"
                                id="montoRecibido"
                                name="contact"
                                value="express"
                                checked={montoRecibido}
                                onChange={() => setMontoRecibido(!montoRecibido)}
                            />
                            &nbsp;&nbsp;
                            <label htmlFor="montoRecibido">Monto que recibí (pagos pendientes)</label>
                        </div>
                        {montoRecibido && (
                            <input
                                className="form-control mb-3"
                                placeholder="Ejm: 12.000 ó 4.000"
                                name="montoRecibidoMsg"
                                type="text"
                                inputMode="numeric"
                                ref={register({
                                    required: false,
                                })}
                            />
                        )}
                    </div>
                    <textarea
                        type="text"
                        className="form-control"
                        name="observationMsg"
                        rows="4"
                        ref={register({
                            required: false,
                        })}
                        placeholder="Complementa con una nota respecto a la entrega. (Opcional)"
                    />
                    <hr />
                    <div className="form-group mb-4 row">
                        <div className="col-xl-12">
                            <label htmlFor="photoOrder">
                                <i className="fa fa-camera"></i> Subir Foto (Opcional)
                            </label>
                            <input
                                className="form-control upload"
                                type="file"
                                name="photoOrder"
                                id="photoOrder"
                                accept="image/*"
                                onChange={handleInputImage}
                                ref={register({
                                    required: false,
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-success btn-lg"
                    onClick={handleSubmit(handleSave)}
                >
                    Guardar
                </button>
            </div>
        </Modal>
    );
};

export default ModalObservation;
